import React from "react";
import { css } from "aphrodite";
import PropTypes from "prop-types";

import { ModalStyles } from "../styles/MainStyle";
import { Title } from "./Title";
import { trodlyGreen } from "../styles/Constants";
import { Paragraph } from "./Paragraph";
import backIcon from "../images/backicon.png";

const ModalWrapper = props => {
  const handleBackgroundClick = e => {
    if (e.target === e.currentTarget) props.hideModal();
  };

  const onOk = () => {
    props.onOk();
    props.hideModal();
  };

  const okButton = props.showOk ? (
    <button className="actionButton" onClick={onOk} disabled={props.okDisabled}>
      {props.okText}
    </button>
  ) : null;

  return (
    <div className={css(ModalStyles.modals)} onClick={handleBackgroundClick}>
      <div className={css(ModalStyles.modalContainer)}>
        <div className={css(ModalStyles.close)} onClick={props.hideModal}>
          <span className={css(ModalStyles.closeIcon)} />
        </div>
        <div className={css(ModalStyles.modalHeader)}>
          {props.back && (
            <div
              onClick={props.back}
              style={{ marginBottom: "1rem", cursor: "pointer" }}
            >
              <div className="img" style={{ height: "1.2rem" }}>
                <img
                  src={backIcon}
                  alt=""
                  style={{ display: "block", height: "100%" }}
                />
              </div>
            </div>
          )}
          <Title color={trodlyGreen} size="1.5rem" margin="0 0 0.2rem">
            {props.title}
          </Title>
          <Paragraph>{props.subtitle}</Paragraph>
        </div>
        <div className={css(ModalStyles.modalBody)}>{props.children}</div>
        <div className={css(ModalStyles.modalFooter)}>{okButton}</div>
      </div>
      {props.footerBanner && (
        <div className={css(ModalStyles.footerBanner)}>
          <div>
            <img
              src={props.footerImage}
              alt=""
              className={css(ModalStyles.footerBannerImage)}
            />
          </div>
          <div>
            <h4 className={css(ModalStyles.footerBannerTitle)}>
              {props.footerPara}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
};

ModalWrapper.propTypes = {
  // props
  title: PropTypes.string,
  showOk: PropTypes.bool,
  okText: PropTypes.string,
  okDisabled: PropTypes.bool,
  width: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string
  ]).isRequired,

  // methods
  hideModal: PropTypes.func,
  onOk: PropTypes.func
};

ModalWrapper.defaultProps = {
  title: "",
  showOk: true,
  okText: "OK",
  okDisabled: false,
  width: 400,
  onOk: () => {},
  subtitle: ""
};

export default ModalWrapper;
